/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientListItemDto } from '../../models/client-list-item-dto';
import { PaginatedDto } from '../../models/paginated-dto';

export interface ClientControllerFindAll$Params {
  firstName?: string;
  lastName?: string;
  birthday?: string;
  officeId?: number;
  housingId?: number;
  active?: boolean;
  page: number;
  limit: number;
  sortCol?: string;
  sortDir?: 'ASC' | 'DESC';
  deleted?: boolean;
}

export function clientControllerFindAll(http: HttpClient, rootUrl: string, params: ClientControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<ClientListItemDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, clientControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('birthday', params.birthday, {});
    rb.query('officeId', params.officeId, {});
    rb.query('housingId', params.housingId, {});
    rb.query('active', params.active, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortCol', params.sortCol, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('deleted', params.deleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDto & {
      'items'?: Array<ClientListItemDto>;
      }>;
    })
  );
}

clientControllerFindAll.PATH = '/api/client';
